import { HarnessWriteTarget } from '@flowx/designer/modules/ai-builder/types/conversation.types'

/**
 * Where a conversation writes, in words (MT-3910). One reading for every surface that names the
 * target — the rail's conversation target, the plan card, the plan view — so the three cannot
 * disagree about where the work lands.
 */

/** How the names service answers: a name, `''` for one it could not find, null while looking. */
export type NameLookup = (id: string) => string | null

export type WriteTargetLabels = {
  project: string
  branch: string
  /** The commit the plan was approved against, shortened the way a commit id is read. */
  startCommit: string | null
  /** The branch it was approved from, when the run moved the target to a branch of its own. */
  startBranch: string | null
}

export function toWriteTargetLabels(
  target: HarnessWriteTarget,
  projectName: NameLookup
): WriteTargetLabels {
  return {
    project: nameOrFallback(
      projectName(target.app_id),
      'another project',
      'a project you cannot open'
    ),
    branch: target.branch_name || 'main',
    startCommit: target.anchor_commit_id ? shortCommitId(target.anchor_commit_id) : null,
    startBranch:
      target.base_branch_name && target.base_branch_name !== target.branch_name
        ? target.base_branch_name
        : null,
  }
}

/** A looked-up name, or what to say while it is looked up and when it was not found. */
export function nameOrFallback(
  name: string | null,
  whileLooking: string,
  whenUnknown: string
): string {
  if (name === null) {
    return whileLooking
  }

  return name || whenUnknown
}

export function shortCommitId(id: string): string {
  return id.length > 8 ? id.slice(0, 8) : id
}
